export type IDaylightSavingAdjust = (date: Date) => Date | null;

export function _daylightSavingAdjust(date: Date): Date | null {
  if (!date) {
    return null;
  }
  date.setHours(date.getHours() > 12 ? date.getHours() + 2 : 0);
  return date;
}
